import { setOpfsPathSegments } from "@/utils/opfs-path"
import { getSampleProjectRootPath } from "./sample-project-loader"
import { ProjectItem } from "./projects-service"

export async function resolveSampleProjectPath(
	rootHandle: FileSystemDirectoryHandle,
	project: ProjectItem,
): Promise<FileSystemDirectoryHandle> {
	const pathSegments = project.handle?.relativePathSegments ?? []
	const rootPath = getSampleProjectRootPath(project.id)
	setOpfsPathSegments(rootHandle, rootPath, { setRelativePath: [] })

	console.info("[SampleProject] Resolving path segments", pathSegments)
	if (!pathSegments.length) {
		return rootHandle
	}

	let currentDirectory = rootHandle
	for (const segment of pathSegments) {
		currentDirectory = await currentDirectory.getDirectoryHandle(segment, { create: false })
	}

	setOpfsPathSegments(currentDirectory, [...rootPath, ...pathSegments], {
		setRelativePath: pathSegments,
	})

	return currentDirectory
}
